<template>
  <router-view :key="$route.name" class="w-full h-full" />
</template>

<script>
export default {
  name: "SettingsIndex",
};
</script>
